import { render, staticRenderFns } from "./InvoiceBadgeStatus.vue?vue&type=template&id=11b8911e&"
import script from "./InvoiceBadgeStatus.vue?vue&type=script&lang=ts&"
export * from "./InvoiceBadgeStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports